import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrder  {
    _originalTypeClassName = "zERP.BO.PaymentOrder";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrder.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.IncomeReceipts = [];
this.DeductionDetails = [];
this.Budget = new Domain.Budget();
this.SettlementDetails = [];
this.Documents = [];
this.FileUploads = [];
this.Id = null;
this.Notes = null;
this.DateCreated = null;
this.DateIssued = null;
this.CancellationDate = null;
this.SystemDateApproved = null;
this.TotalAmount = null;
this.TotalDeduction = null;
this.TotalPrepayments = null;
this.TotalPaymentOrderedAmount = null;
this.PayableAmount = null;
this.RemainingPaymentOrderedAmount = null;
this.Status = null;
this.IsPayed = false;
this.Type = null;
this.DateApproved = null;
this.ApprovalReference = null;
this.Number = null;
this.DeductionsTreasuryStr = null;
this.DeductionsDescriptionStr = null;
this.SeriesCode = null;
this.SeriesAndCodeStr = null;
this.MappedWithAccounting = false;
this.ProtocolNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Notes:any;
DateCreated:any;
DateIssued:any;
CancellationDate:any;
SystemDateApproved:any;
TotalAmount:any;
TotalDeduction:any;
TotalPrepayments:any;
TotalPaymentOrderedAmount:any;
PayableAmount:any;
RemainingPaymentOrderedAmount:any;
Status:any;
IsPayed:any;
Type:any;
DateApproved:any;
ApprovalReference:any;
Number:any;
DeductionsTreasuryStr:any;
DeductionsDescriptionStr:any;
SeriesCode:any;
SeriesAndCodeStr:any;
MappedWithAccounting:any;
ProtocolNumber:any;
Entity:any;
TransactionEntity:any;
CreatedBy:any;
IssuedBy:any;
ApprovedBy:any;
IncomeReceipts:any;
FiscalYear:any;
DeductionDetails:any;
Budget:any;
SettlementDetails:any;
Payment:any;
Documents:any;
Series:any;
Cancellation:any;
FileUploads:any;
PaymentOrderList:any;
PaymentOrderPaymentList:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setIssuedBy = ($this, value) => {
var oldValue = $this.IssuedBy;
$this.IssuedBy = value;
if (value != null) {
}
}
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}
static setIncomeReceipts = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeReceipts == null) $this.IncomeReceipts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeReceipts.length > 0) {
                    Domain.PaymentOrder.removeIncomeReceipts($this, $this.IncomeReceipts[0]);
                }

                Domain.PaymentOrder.addManyIncomeReceipts($this, copyItems);
            }
static addManyIncomeReceipts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrder.addIncomeReceipts($this, items[i]);
                }
            }
static addIncomeReceipts = ($this, item) => {
                if ($this.IncomeReceipts == null) $this.IncomeReceipts = [];
                if (item == null || $this.IncomeReceipts.indexOf(item) > -1) return;
                $this.IncomeReceipts.push(item);
if (item.OwnerPaymentOrder != $this) {
Domain.IncomeReceipt.setOwnerPaymentOrder(item, $this);
}
}
static addRangeIncomeReceipts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrder.addIncomeReceipts($this, item));
            }
static removeIncomeReceipts = ($this, item) => {
                if ($this == null || $this.IncomeReceipts == null || $this.IncomeReceipts.indexOf(item) === -1) return;
                var _index = $this.IncomeReceipts.indexOf(item);
                $this.IncomeReceipts.splice(_index, 1);
item.OwnerPaymentOrder = null;
}
static clearIncomeReceipts = ($this) => { $this.IncomeReceipts = null; }
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setDeductionDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.DeductionDetails == null) $this.DeductionDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DeductionDetails.length > 0) {
                    Domain.PaymentOrder.removeDeductionDetails($this, $this.DeductionDetails[0]);
                }

                Domain.PaymentOrder.addManyDeductionDetails($this, copyItems);
            }
static addManyDeductionDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrder.addDeductionDetails($this, items[i]);
                }
            }
static addDeductionDetails = ($this, item) => {
                if ($this.DeductionDetails == null) $this.DeductionDetails = [];
                if (item == null || $this.DeductionDetails.indexOf(item) > -1) return;
                $this.DeductionDetails.push(item);
if (item.NormalPaymentOrder != $this) {
Domain.PaymentOrderDeductionDetail.setNormalPaymentOrder(item, $this);
}
}
static addRangeDeductionDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrder.addDeductionDetails($this, item));
            }
static removeDeductionDetails = ($this, item) => {
                if ($this == null || $this.DeductionDetails == null || $this.DeductionDetails.indexOf(item) === -1) return;
                var _index = $this.DeductionDetails.indexOf(item);
                $this.DeductionDetails.splice(_index, 1);
item.NormalPaymentOrder = null;
}
static clearDeductionDetails = ($this) => { $this.DeductionDetails = null; }
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
}
}
static setSettlementDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.SettlementDetails == null) $this.SettlementDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SettlementDetails.length > 0) {
                    Domain.PaymentOrder.removeSettlementDetails($this, $this.SettlementDetails[0]);
                }

                Domain.PaymentOrder.addManySettlementDetails($this, copyItems);
            }
static addManySettlementDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrder.addSettlementDetails($this, items[i]);
                }
            }
static addSettlementDetails = ($this, item) => {
                if ($this.SettlementDetails == null) $this.SettlementDetails = [];
                if (item == null || $this.SettlementDetails.indexOf(item) > -1) return;
                $this.SettlementDetails.push(item);
if (item.SettlementPaymentOrder != $this) {
Domain.PaymentOrderDeductionDetail.setSettlementPaymentOrder(item, $this);
}
}
static addRangeSettlementDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrder.addSettlementDetails($this, item));
            }
static removeSettlementDetails = ($this, item) => {
                if ($this == null || $this.SettlementDetails == null || $this.SettlementDetails.indexOf(item) === -1) return;
                var _index = $this.SettlementDetails.indexOf(item);
                $this.SettlementDetails.splice(_index, 1);
item.SettlementPaymentOrder = null;
}
static clearSettlementDetails = ($this) => { $this.SettlementDetails = null; }
static setPayment = ($this, value) => {
var oldValue = $this.Payment;
$this.Payment = value;
if (value != null) {
if (oldValue != null && oldValue.PaymentOrder != null) { oldValue.PaymentOrder = null; }
if ($this.Payment.PaymentOrder !== $this) {
Domain.Payment.setPaymentOrder(value, $this);
}
}
}
static setDocuments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Documents == null) $this.Documents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Documents.length > 0) {
                    Domain.PaymentOrder.removeDocuments($this, $this.Documents[0]);
                }

                Domain.PaymentOrder.addManyDocuments($this, copyItems);
            }
static addManyDocuments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrder.addDocuments($this, items[i]);
                }
            }
static addDocuments = ($this, item) => {
                if ($this.Documents == null) $this.Documents = [];
                if (item == null || $this.Documents.indexOf(item) > -1) return;
                $this.Documents.push(item);
if (item.PaymentOrder != $this) {
Domain.PaymentOrderInvoice.setPaymentOrder(item, $this);
}
}
static addRangeDocuments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrder.addDocuments($this, item));
            }
static removeDocuments = ($this, item) => {
                if ($this == null || $this.Documents == null || $this.Documents.indexOf(item) === -1) return;
                var _index = $this.Documents.indexOf(item);
                $this.Documents.splice(_index, 1);
item.PaymentOrder = null;
}
static clearDocuments = ($this) => { $this.Documents = null; }
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}
static setCancellation = ($this, value) => {
var oldValue = $this.Cancellation;
$this.Cancellation = value;
if (value != null) {
}
}
static setFileUploads = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileUploads == null) $this.FileUploads = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileUploads.length > 0) {
                    Domain.PaymentOrder.removeFileUploads($this, $this.FileUploads[0]);
                }

                Domain.PaymentOrder.addManyFileUploads($this, copyItems);
            }
static addManyFileUploads = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrder.addFileUploads($this, items[i]);
                }
            }
static addFileUploads = ($this, item) => {
                if ($this.FileUploads == null) $this.FileUploads = [];
                if (item == null || $this.FileUploads.indexOf(item) > -1) return;
                $this.FileUploads.push(item);
}
static addRangeFileUploads = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrder.addFileUploads($this, item));
            }
static removeFileUploads = ($this, item) => {
                if ($this == null || $this.FileUploads == null || $this.FileUploads.indexOf(item) === -1) return;
                var _index = $this.FileUploads.indexOf(item);
                $this.FileUploads.splice(_index, 1);
}
static clearFileUploads = ($this) => { $this.FileUploads = null; }
static setPaymentOrderList = ($this, value) => {
var oldValue = $this.PaymentOrderList;
$this.PaymentOrderList = value;
if (value != null) {
if (oldValue != null) {
Domain.PaymentOrderList.removePaymentOrders(oldValue, $this);
}
Domain.PaymentOrderList.addPaymentOrders(value, $this);
}
}
static setPaymentOrderPaymentList = ($this, value) => {
var oldValue = $this.PaymentOrderPaymentList;
$this.PaymentOrderPaymentList = value;
if (value != null) {
if (oldValue != null) {
Domain.PaidPaymentOrdersList.removePaymentOrders(oldValue, $this);
}
Domain.PaidPaymentOrdersList.addPaymentOrders(value, $this);
}
}

static AutoLoadDeductions($this: any): any{$this.TotalDeduction = 0;
if ($this?.Type != Domain.PaymentOrderType.Normal || !($this?.Documents?.linq?.any())) {return;}
let deductions = [];
for (let _idoc = 0; _idoc < ($this?.Documents == null ? 0 : $this?.Documents.length); _idoc++) {let doc = $this?.Documents[_idoc];if (doc?.Invoice?.TaxesPerInvoiceLine) {for (let _idocLine = 0; _idocLine < (doc?.Invoice?.InvoiceDetails == null ? 0 : doc?.Invoice?.InvoiceDetails.length); _idocLine++) {let docLine = doc?.Invoice?.InvoiceDetails[_idocLine];if (docLine?.WithheldPercentCategory != null) {let line = new Domain.PaymentOrderDeductionDetail();Domain.PaymentOrderDeductionDetail.setTaxCategory(line, docLine?.WithheldPercentCategory);line.Amount = docLine?.WithheldAmount;deductions?.add(line);}if (docLine?.StampDutyPercentCategory != null) {let line = new Domain.PaymentOrderDeductionDetail();Domain.PaymentOrderDeductionDetail.setTaxCategory(line, docLine?.StampDutyPercentCategory);line.Amount = docLine?.StampDutyAmount;deductions?.add(line);}if (docLine?.DeductionsPercentCategory != null) {let line = new Domain.PaymentOrderDeductionDetail();Domain.PaymentOrderDeductionDetail.setTaxCategory(line, docLine?.DeductionsPercentCategory);line.Amount = docLine?.DeductionsAmount;deductions?.add(line);}}}else {for (let _itax = 0; _itax < (doc?.Invoice?.TaxesTotals == null ? 0 : doc?.Invoice?.TaxesTotals.length); _itax++) {let tax = doc?.Invoice?.TaxesTotals[_itax];if (tax?.Tax?.Type != Domain.TaxType.WithHeld && tax?.Tax?.Type != Domain.TaxType.Deduction && tax?.Tax?.Type != Domain.TaxType.StampDuty) {continue;}let line = new Domain.PaymentOrderDeductionDetail();Domain.PaymentOrderDeductionDetail.setTaxCategory(line, tax?.Tax);line.Amount = tax?.TaxAmount;deductions?.add(line);}}}
if (!(deductions?.linq?.any())) {return;}
$this.TotalDeduction = deductions?.linq?.sum((d) => d?.Amount);
let detailsToRemove = [];
for (let _idetail = 0; _idetail < ($this?.DeductionDetails == null ? 0 : $this?.DeductionDetails.length); _idetail++) {let detail = $this?.DeductionDetails[_idetail];if (!(deductions?.linq?.any((d) => d?.TaxCategory == detail?.TaxCategory))) {detailsToRemove?.add(detail);}}
while (detailsToRemove?.linq?.any()) {let toRemove = detailsToRemove?.linq?.where()?.firstOrDefault(null);$this?.DeductionDetails?.splice($this?.DeductionDetails.indexOf(toRemove), 1);detailsToRemove?.splice(detailsToRemove.indexOf(toRemove), 1);}
for (let _idetail = 0; _idetail < (deductions == null ? 0 : deductions.length); _idetail++) {let detail = deductions[_idetail];let existing = $this?.DeductionDetails?.linq?.where((d) => d?.TaxCategory == detail?.TaxCategory)?.firstOrDefault(null);if (existing == null) {existing = new Domain.PaymentOrderDeductionDetail();Domain.PaymentOrderDeductionDetail.setTaxCategory(existing, detail?.TaxCategory);existing.Amount = 0;$this?.DeductionDetails?.add(existing);}existing.Amount = Joove.Common.safeNumber(existing?.Amount) + Joove.Common.safeNumber(detail?.Amount);}
}
static AutoLoadInvoices($this: any, invoices: any): any{for (let _iinvoice = 0; _iinvoice < (invoices == null ? 0 : invoices.length); _iinvoice++) {let invoice = invoices[_iinvoice];console.info("AutoLoadInvoices|| invoice: " + Joove.Common.safeNumber(invoice?.Id));if ($this?.Documents?.linq?.any((d) => CLMS.Framework.Number.Equal(() => d.Invoice.Id, () => invoice.Id))) {continue;}console.info("AutoLoadInvoices|| Adding new document based on invoice");let paymentOrderInvoice = new Domain.PaymentOrderInvoice();Domain.PaymentOrderInvoice.setInvoice(paymentOrderInvoice, invoice);paymentOrderInvoice.Amount = Domain.PaymentOrderInvoice.GetRemainingAmount(paymentOrderInvoice);console.info("AutoLoadInvoices|| paymentOrderInvoice.Amount: " + Joove.Common.safeNumber(paymentOrderInvoice?.Amount));$this?.Documents?.add(paymentOrderInvoice);console.info("AutoLoadInvoices|| this.Documents length: " + Joove.Common.safeNumber($this?.Documents?.length));}
let toRemove = [];
for (let _ipaymentOrderInvoice = 0; _ipaymentOrderInvoice < ($this?.Documents == null ? 0 : $this?.Documents.length); _ipaymentOrderInvoice++) {let paymentOrderInvoice = $this?.Documents[_ipaymentOrderInvoice];if (invoices?.linq?.any((i) => CLMS.Framework.Number.Equal(() => paymentOrderInvoice.Invoice.Id, () => i.Id))) {continue;}console.info("AutoLoadInvoices|| Removing obsolete invoice: " + Joove.Common.safeNumber(paymentOrderInvoice?.Invoice?.Id));toRemove?.add(paymentOrderInvoice);}
for (let _ipaymentOrderInvoice = 0; _ipaymentOrderInvoice < (toRemove == null ? 0 : toRemove.length); _ipaymentOrderInvoice++) {let paymentOrderInvoice = toRemove[_ipaymentOrderInvoice];$this?.Documents?.splice($this?.Documents.indexOf(paymentOrderInvoice), 1);}
}
static AutoLoadSpendingRequests($this: any): any{for (let _ipaymentOrderInvoice = 0; _ipaymentOrderInvoice < ($this?.Documents == null ? 0 : $this?.Documents.length); _ipaymentOrderInvoice++) {let paymentOrderInvoice = $this?.Documents[_ipaymentOrderInvoice];for (let _idetail = 0; _idetail < (paymentOrderInvoice?.Details == null ? 0 : paymentOrderInvoice?.Details.length); _idetail++) {let detail = paymentOrderInvoice?.Details[_idetail];detail.Amount = 0;detail.Deductions = 0;}for (let _idocLine = 0; _idocLine < (paymentOrderInvoice?.Invoice?.InvoiceDetails == null ? 0 : paymentOrderInvoice?.Invoice?.InvoiceDetails.length); _idocLine++) {let docLine = paymentOrderInvoice?.Invoice?.InvoiceDetails[_idocLine];console.warn(" -- Checking Line ");let spendingRequestDetail = (docLine?.SpendingRequestInvoicing != null && docLine?.SpendingRequestInvoicing?.Invoiced != null ? docLine?.SpendingRequestInvoicing?.SpendingRequestDetail : null);let existing = paymentOrderInvoice?.Details?.linq?.where((d) => d?.SpendingRequestDetail == spendingRequestDetail)?.firstOrDefault(null);if (existing == null) {existing = new Domain.PaymentOrderDetail();Domain.PaymentOrderDetail.setSpendingRequestDetail(existing, spendingRequestDetail);existing.Amount = 0;paymentOrderInvoice?.Details?.add(existing);}existing.Amount = Joove.Common.safeNumber(existing?.Amount) + Joove.Common.safeNumber(docLine?.GrossValue);existing.Deductions = Joove.Common.safeNumber(existing?.Deductions) + Joove.Common.safeNumber(docLine?.TotalDeductionsAmount);let otherPaymentOrderDetails = (Joove.Common.cast(paymentOrderInvoice?.Invoice?.PaymentOrderInvoices?.linq?.where((i) => !(Domain.PaymentOrderInvoice.IsNew(i)))?.toArray()?.linq?.selectMany((i) => i?.Details)?.toArray(), "System.Collections.List"))?.linq?.where((d) => (d?.SpendingRequestDetail == null || existing?.SpendingRequestDetail == null || CLMS.Framework.Number.Equal(() => d.SpendingRequestDetail.Id, () => existing.SpendingRequestDetail.Id)) && CLMS.Framework.Number.NotEqual(() => d.Id, () => existing.Id))?.toArray();existing.PayableAmount = Joove.Common.safeNumber(existing?.Amount) - Joove.Common.safeNumber(existing?.Deductions) - Joove.Common.safeNumber(otherPaymentOrderDetails?.linq?.sum((d) => d?.PayableAmount));}let detailsToRemove = [];for (let _idetail = 0; _idetail < (paymentOrderInvoice?.Details == null ? 0 : paymentOrderInvoice?.Details.length); _idetail++) {let detail = paymentOrderInvoice?.Details[_idetail];if (!(paymentOrderInvoice?.Invoice?.InvoiceDetails?.linq?.any((d) => (d?.SpendingRequestInvoicing == null && detail?.SpendingRequestDetail == null) || (d?.SpendingRequestInvoicing != null && d?.SpendingRequestInvoicing?.SpendingRequestDetail == detail?.SpendingRequestDetail)))) {detailsToRemove?.add(detail);}}while (detailsToRemove?.linq?.any()) {let toRemove = detailsToRemove?.linq?.where()?.firstOrDefault(null);paymentOrderInvoice?.Details?.splice(paymentOrderInvoice?.Details.indexOf(toRemove), 1);detailsToRemove?.splice(detailsToRemove.indexOf(toRemove), 1);}let docsWithTaxesOnTotal = $this?.Documents?.linq?.where((d) => d?.Invoice?.TaxesPerInvoiceLine != true)?.toArray()?.linq?.select((d) => d?.Invoice)?.toArray();for (let _idocument = 0; _idocument < (docsWithTaxesOnTotal == null ? 0 : docsWithTaxesOnTotal.length); _idocument++) {let document = docsWithTaxesOnTotal[_idocument];let docLine = document?.InvoiceDetails?.linq?.where((line) => line?.SpendingRequestInvoicing != null && line?.SpendingRequestInvoicing?.Invoiced)?.firstOrDefault(null);if (docLine == null) {continue;}let detail = paymentOrderInvoice?.Details?.linq?.where((d) => d?.SpendingRequestDetail != null && CLMS.Framework.Number.Equal(() => d.SpendingRequestDetail.Id, () => docLine.SpendingRequestInvoicing.SpendingRequestDetail.Id))?.firstOrDefault(null);if (detail == null) {continue;}let deductionsAmount = Joove.Common.safeNumber(document?.InvoiceSummary?.TotalNonPrepaidWithheldAmount) + Joove.Common.safeNumber(document?.InvoiceSummary?.TotalStampDutyAmount);let taxesAmount = Joove.Common.safeNumber(document?.InvoiceSummary?.TotalFeesAmount) + Joove.Common.safeNumber(document?.InvoiceSummary?.TotalOtherTaxesAmount);detail.Amount = Joove.Common.safeNumber(detail?.Amount) + Joove.Common.safeNumber(taxesAmount);detail.Deductions = Joove.Common.safeNumber(detail?.Deductions) + Joove.Common.safeNumber(deductionsAmount);detail.PayableAmount = Joove.Common.safeNumber(detail?.PayableAmount) + Joove.Common.safeNumber(taxesAmount) - Joove.Common.safeNumber(deductionsAmount);}}
}
static DELETEMELoadSpendingClaims($this: any): any{}
static GetClassName(): any{return "PaymentOrder";
}
static GetRemainingPaymentOrderedAmount($this: any): any{return Joove.Common.safeNumber($this?.TotalPaymentOrderedAmount) - Joove.Common.safeNumber($this?.PayableAmount);
}
static IsAmountValid($this: any): any{if ($this?.Type == Domain.PaymentOrderType.Prepayment) {return true;}
if ($this?.Type == Domain.PaymentOrderType.Deductions) {return true;}
if ($this?.Type == Domain.PaymentOrderType.Normal) {return true;}
return true;
}
static IsPayableAmountValid($this: any): any{if ($this?.Type == Domain.PaymentOrderType.Prepayment) {let documentsAmount = $this?.Documents?.linq?.sum((d) => d?.Amount);if (CLMS.Framework.Number.GreaterThan(() => $this.Documents.linq.sum((d) => d.Amount), () => $this.PayableAmount)) {console.info("IsPayableAmountValid: " + Joove.Common.safeNumber($this?.PayableAmount) + "  " + Joove.Common.safeNumber($this?.Documents?.linq?.sum((d) => d?.Amount)));return false;}return true;}
if (!(Domain.CommonMethodsHelper.AmountsAreEqual($this?.PayableAmount, $this?.Documents?.linq?.sum((d) => d?.Amount), null))) {console.info("IsPayableAmountValid: " + Joove.Common.safeNumber($this?.PayableAmount) + "  " + Joove.Common.safeNumber($this?.Documents?.linq?.sum((d) => d?.Amount)));return false;}
return true;
}
static IsPaymentOrderInvoicePayableAmountValid($this: any, paymentOrderInvoice: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => paymentOrderInvoice.Details.length, () => 0)) {return true;}
if (!(Domain.CommonMethodsHelper.AmountsAreEqual(paymentOrderInvoice?.Amount, paymentOrderInvoice?.Details?.linq?.sum((d) => d?.PayableAmount), null))) {console.info("IsPaymentOrderInvoicePayableAmountValid: " + Joove.Common.safeNumber(paymentOrderInvoice?.Amount) + "  " + Joove.Common.safeNumber(paymentOrderInvoice?.Details?.linq?.sum((d) => d?.PayableAmount)));return false;}
return true;
}
static UpdateDocumentLinesPayableAmounts($this: any): any{for (let _ipaymentOrderInvoice = 0; _ipaymentOrderInvoice < ($this?.Documents == null ? 0 : $this?.Documents.length); _ipaymentOrderInvoice++) {let paymentOrderInvoice = $this?.Documents[_ipaymentOrderInvoice];let totalAmount = paymentOrderInvoice?.Details?.linq?.sum((d) => d?.PayableAmount);for (let _idetail = 0; _idetail < (paymentOrderInvoice?.Details == null ? 0 : paymentOrderInvoice?.Details.length); _idetail++) {let detail = paymentOrderInvoice?.Details[_idetail];if (CLMS.Framework.Number.Equal(() => totalAmount, () => 0)) {detail.PayableAmount = Joove.Common.safeNumber(paymentOrderInvoice?.Amount) / Joove.Common.safeNumber(paymentOrderInvoice?.Details?.length);continue;}detail.PayableAmount = Joove.Common.safeNumber(paymentOrderInvoice?.Amount) * Joove.Common.safeNumber((Joove.Common.safeNumber(detail?.PayableAmount) / Joove.Common.safeNumber(totalAmount)));}}
}
static UpdateDocumentsPayableAmount($this: any): any{for (let _ipaymentOrderInvoice = 0; _ipaymentOrderInvoice < ($this?.Documents == null ? 0 : $this?.Documents.length); _ipaymentOrderInvoice++) {let paymentOrderInvoice = $this?.Documents[_ipaymentOrderInvoice];paymentOrderInvoice.Amount = paymentOrderInvoice?.Details?.linq?.sum((d) => d?.PayableAmount);}
}
static UpdateSeriesAndCodeStr($this: any): any{let series = ($this?.Series != null && !(Domain.PaymentOrderSeries.IsNew($this?.Series)) ? $this?.Series?.Name : "");
let code = (CLMS.Framework.Number.NotEqual(() => $this.SeriesCode, () => null) && CLMS.Framework.Number.GreaterThan(() => $this.SeriesCode, () => 0) ? $this?.SeriesCode?.toString() : "");
$this.SeriesAndCodeStr = series + "-" + code;
}
static Validate($this: any): any{for (let _ipaymentOrderInvoice = 0; _ipaymentOrderInvoice < ($this?.Documents == null ? 0 : $this?.Documents.length); _ipaymentOrderInvoice++) {let paymentOrderInvoice = $this?.Documents[_ipaymentOrderInvoice];if (!(Domain.PaymentOrder.IsPaymentOrderInvoicePayableAmountValid($this, paymentOrderInvoice))) {return "Το ποσό πληρωμής του παραστατικού δεν είναι σωστό";}}
if (!(Domain.PaymentOrder.IsPayableAmountValid($this))) {return "Το ποσό πληρωμής δεν είναι σωστό";}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}